/** ゆうちょ銀行の金融機関コード（BankcodeJP） */
export const YUCHO_BANK_CODE = "9900";

const KANJI_DIGITS = [
  "〇",
  "一",
  "二",
  "三",
  "四",
  "五",
  "六",
  "七",
  "八",
  "九",
] as const;

/** 支店検索入力が半角数字のみ（1〜3桁）か */
export function isHalfWidthNumericBranchInput(input: string): boolean {
  return /^[0-9]{1,3}$/.test(input.trim());
}

/** 半角数字を漢数字表記へ変換（例: 058 → 〇五八） */
export function convertHalfWidthDigitsToKanji(input: string): string {
  return input.replace(/[0-9]/g, (digit) => KANJI_DIGITS[Number(digit)]);
}

/** 支店コードを3桁ゼロ埋め（例: 58 → 058） */
export function padBranchCodeToThreeDigits(input: string): string {
  return input.padStart(3, "0");
}

/**
 * 先頭ゼロ省略入力向けに、3桁ゼロ埋めでの直接取得を試行するか。
 * 例: 58 → 058。05 のように先頭が 0 の部分入力は対象外。
 */
export function shouldTryZeroPaddedDirectBranchFetch(input: string): boolean {
  return input.length < 3 && !input.startsWith("0");
}

/** 直接取得 API 用に試行する支店コード一覧 */
export function directFetchBranchCodes(input: string): string[] {
  const trimmed = input.trim();
  if (trimmed.length === 3) {
    return [trimmed];
  }
  if (shouldTryZeroPaddedDirectBranchFetch(trimmed)) {
    return [padBranchCodeToThreeDigits(trimmed)];
  }
  return [];
}
